<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { cn } from "$lib/utils"
  import { CalendarDate } from "@internationalized/date"
  import ChevronLeftIcon from "@lucide/svelte/icons/chevron-left"
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right"

  let { selected, onSelect, class: className }: {
    selected?: { year: number, month: number }
    onSelect: (date: CalendarDate) => void
    class?: string
  } = $props()

  let year = $state(new Date().getFullYear())

  const months = $derived(
    Array.from({ length: 12 }, (_, index) => ({
      month: index + 1,
      label: new Date(year, index, 1).toLocaleString("id", { month: "long" }),
    }))
  )

  $effect.pre(() => {
    if (selected) {
      year = selected.year
    }
  })

</script>

<div class={cn("space-y-3 p-3", className)}>
  <div class="flex items-center justify-between px-1">
    <Button
      variant="outline"
      class="size-7 p-0 opacity-50 transition-colors"
      onclick={() => year -= 1}>
      <ChevronLeftIcon/>
    </Button>
    <div class="text-sm font-bold">{year}</div>
    <Button
      variant="outline"
      class="size-7 p-0 opacity-50 transition-colors"
      onclick={() => year += 1}>
      <ChevronRightIcon/>
    </Button>
  </div>
  <div class="grid grid-cols-3 text-center">
    {#each months as item (item.month)}
      <Button
        variant="ghost"
        class={cn(
          "h-auto px-1.5 py-2 text-xs",
          selected?.year === year && selected?.month === item.month && "bg-muted",
        )}
        onclick={() => onSelect(new CalendarDate(year, item.month, 1))}>
        {item.label}
      </Button>
    {/each}
  </div>
</div>
